import React , {useEffect, useRef}from 'react'

const Text = (props) => {
    const userplay = props.useStore(state => state.userplay)
    const userPlayRock = props.useStore(state => state.userPlayRock)
    const userPlayPaper = props.useStore(state => state.userPlayPaper)
    const userPlayScissors = props.useStore(state => state.userPlayScissors)
    const gameReset = props.useStore(state => state.gameReset)

    const aiPlay = props.useStoreAI(state => state.aiPlay)
    const aiplay = props.useStoreAI(state => state.aiplay)
    const aiReset = props.useStoreAI(state => state.aiReset)

    const rockButton = useRef()
    const paperButton = useRef()
    const scissorsButton = useRef()
    const info = useRef()

    const checkWin = (u, a)=>{
    
        if( u == a && u != ''){
            info.current.innerText = `it's a tie`
        }else{
            if( u == 'rock'){
                if( a == 'paper'){
                    info.current.innerText = `you lost`
                }
                if( a == 'scissors'){
                    info.current.innerText = `you win`
                }
            }
            if( u == 'paper'){
                if( a == 'rock'){
                    info.current.innerText = `you win`
                }
                if( a == 'scissors'){
                    info.current.innerText = `you lost`
                }
            }
            if( u == 'scissors'){
                if( a == 'paper'){
                    info.current.innerText = `you win`
                }
                if( a == 'rock'){
                    info.current.innerText = `you lost`
                }
            }
        }
       
    }

    useEffect(()=>{
        console.log(userplay, aiplay)
        if(userplay == 'rock'){

            paperButton.current.style.display = 'none'
            scissorsButton.current.style.display = 'none'
        }
        if(userplay == 'paper'){

            rockButton.current.style.display = 'none'
            scissorsButton.current.style.display = 'none'
        }
        if(userplay == 'scissors'){

            paperButton.current.style.display = 'none'
            rockButton.current.style.display = 'none'
        }

        let timeoutReset
        const timeout = setTimeout( ()=>{

            checkWin(userplay, aiplay)
            timeoutReset = setTimeout(()=>{

                gameReset()
                aiReset()
                paperButton.current.style.display = 'unset'
                scissorsButton.current.style.display = 'unset'
                rockButton.current.style.display = 'unset'

            }, 2000)

        }, 2000)
       
        return ()=>{
            clearTimeout(timeout)
            clearTimeout(timeoutReset)
        }
    }, [userplay, aiplay])
    
    return (
        <div>
            <div ref={info} className="email">{ userplay == '' ? `LET'S PLAY` : `YOU PLAY ${userplay}`}</div>
            <div className="buttons">
                <div ref={rockButton} className={ userplay == 'rock' ? "button button-select" : "button" } onClick={()=>{userPlayRock();aiPlay();checkWin()}}>Rock</div>
                <div ref={paperButton} className={ userplay == 'paper' ? "button button-select" : "button" } onClick={()=>{userPlayPaper(); aiPlay();checkWin()}}>Paper</div>
                <div ref={scissorsButton} className={ userplay == 'scissors' ? "button button-select" : "button" } onClick={()=>{userPlayScissors(); aiPlay();checkWin()}}>Scissors</div>
            </div>
        </div>
    )
}

export default Text